import { render, staticRenderFns } from "./OrgReports.vue?vue&type=template&id=2f67bb05"
import script from "./OrgReports.vue?vue&type=script&lang=js"
export * from "./OrgReports.vue?vue&type=script&lang=js"
import style0 from "./OrgReports.vue?vue&type=style&index=0&id=2f67bb05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports